<template>
  <div class="upload-view">
    <div class="upload-toolbar">
      <span class="upload-toolbar-label">产品上传</span>
      <button class="clear-task-btn" @click="onClearTask">清空任务</button>
    </div>
    <div v-for="(product, idx) in workbench.products" :key="product.id" class="product-row-wrapper">
      <ProductRow :product="product" :productIndex="idx" />
    </div>
  </div>
</template>

<script setup>
import { useWorkbenchStore } from '@/stores/useWorkbenchStore'
import ProductRow from '@/components/upload/ProductRow.vue'

const workbench = useWorkbenchStore()

const onClearTask = () => {
  if (!confirm('确定要清空当前任务吗？\n\n所有产品（A/B/C）的上传图片都会被删除，且无法恢复。')) return
  workbench.clearAllTask()
}
</script>

<style scoped>
.upload-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px 12px;
}
.upload-toolbar-label {
  font-size: 15px;
  font-weight: 600;
  color: #1d2129;
}
</style>
